import type { RouteObject } from 'react-router';

import { lazy } from 'react';
import { Outlet } from 'react-router-dom';
import { GuestGuard } from 'src/guards/guest-guard';
import { Layout as AuthLayout } from 'src/layouts/auth/classic-layout';

const LoginPage = lazy(() => import('src/pages/auth/login'));
const ForgetPasswordPage = lazy(() => import('src/pages/auth/forget-password'));

export const authRoutes: RouteObject[] = [
  {
    path: 'auth',
    children: [
      {
        element: (
          <GuestGuard>
            <AuthLayout>
              <Outlet />
            </AuthLayout>
          </GuestGuard>
        ),
        children: [
          {
            path: 'login',
            element: <LoginPage />,
          },
          {
            path: 'forget-password',
            element: <ForgetPasswordPage />,
          },
        ],
      },
    ],
  },
];
